import React from 'react';
import { Carousel, Card } from 'antd';
import { CarouselWrapper, CardWrapper, StyledPopover } from './styled';

const { Meta } = Card;

function Content({ cards, cardHeight, carouselWidth, footer = null }) {
  return (
    <CarouselWrapper className="color-critical">
      <Carousel dotPosition="bottom" autoplay style={{ width: carouselWidth }}>
        {cards.map(({ title, description, img }) => (
          <CardWrapper height={cardHeight} key={title}>
            <Card cover={<img alt="-" src={img} />} variant="borderless">
              <Meta title={title} description={description} />
            </Card>
          </CardWrapper>
        ))}
      </Carousel>
      {footer}
    </CarouselWrapper>
  );
}

function InfoPopover({
  children = null,
  cards = [],
  footer = null,
  cardHeight = 350,
  carouselWidth = 370,
}) {
  return (
    <StyledPopover
      placement="bottomRight"
      content={
        <Content
          cards={cards}
          footer={footer}
          cardHeight={cardHeight}
          carouselWidth={carouselWidth}
        />
      }
      trigger="click"
      overlayClassName="info-popover"
    >
      {children}
    </StyledPopover>
  );
}

export default InfoPopover;
